import { createDraftSafeSelector, createSelector } from "@reduxjs/toolkit";

import { selectShippingPrice } from "../checkout/checkout.selectors";
import { CartItem } from "./cart.types";

const selectCart = (state: any) => state.cart;

export const selectCartItems = createDraftSafeSelector(
  [selectCart],
  (cart) => cart.cartItems,
);

export const selectCartOpen = createDraftSafeSelector(
  [selectCart],
  (cart) => cart.open,
);

export const selectIsCartFetching = createDraftSafeSelector(
  [selectCart],
  (cart) => cart.isCartFetching,
);

export const selectIsCartItemAdding = createDraftSafeSelector(
  [selectCart],
  (cart) => cart.isCartItemAdding,
);

export const selectIsCartItemRemoving = createDraftSafeSelector(
  [selectCart],
  (cart) => cart.isCartItemRemoving,
);

export const selectIsCartItemClearing = createDraftSafeSelector(
  [selectCart],
  (cart) => cart.isCartItemClearing,
);

export const selectCartItemsCount = createDraftSafeSelector(
  [selectCartItems],
  (cartItems) =>
    cartItems
      ? cartItems?.reduce(
          (accumulatedQuantity: number, cartItem: any) =>
            accumulatedQuantity + cartItem.quantity,
          0,
        )
      : 0,
);

export const selectCartTotal = createSelector([selectCartItems], (cartItems) =>
  parseFloat(
    cartItems && cartItems.length !== 0
      ? cartItems.reduce(
          (accumulatedQuantity: number, cartItem: any) =>
            accumulatedQuantity +
            parseFloat(cartItem?.quantity) *
              parseFloat(
                cartItem?.priceSalesNow
                  ? cartItem?.priceSalesNow
                  : cartItem?.priceNow,
              ),
          0,
        )
      : 0,
  ),
);
